import {IMenu} from '../core/models/menu.model';

export const appMenu: IMenu = [
  {
    name: 'dashboard',
    label: 'Dashboard',
    icon: 'dashboard',
    link: '/dashboard'
  },
  {
    name: 'punti-campionamento',
    label: 'Piano Dei controlli',
    icon: 'pin_drop',
    subMenu: [
      {
        name: 'punti-campionamento-lista',
        label: 'Punti di Campionamento',
        labelPage: 'Lista',
        icon: 'pin_drop',
        link: '/punti-campionamento/lista',
        // separator: true
      },
      {
        name: 'punti-campionamento-tipologie',
        label: 'Tipologie',
        icon: 'edit_location_alt',
        link: '/punti-campionamento-tipologie/lista',
        // separator: true
      },
      {
        name: 'punti-campionamento-invio-file',
        label: 'Caricamento tramite file',
        icon: 'upload_file',
        link: '/punti-campionamento/invio-file',
        // separator: true
      },
      {
        name: 'punti-campionamento-scaduti',
        label: 'Punti campionamento scaduti',
        icon: 'error',
        link: '/punti-campionamento/scaduti'
      }

    ]
  },
  {
    name: 'controlli',
    label: 'Controlli',
    icon: 'fact_check',
    subMenu: [
      {
        name: 'controlli_lista',
        label: 'Visualizza dati dei controlli',
        icon: 'list',
        link: '/controlli/lista',
        separator: true,
      },
      {
        name: 'controlli_invio_dati',
        label: 'Invio Controllo',
        icon: 'cloud_upload',
        link: '/controlli/invio-dati'
      },
      {
        name: 'controlli_invio_file',
        label: 'Caricamento tramite file',
        icon: 'upload_file',
        link: '/controlli/invio-file'
      },
      {
        name: 'controlli_dettaglio',
        label: 'Visualizza dati dei controlli',
        link: '/controlli/dettaglio',
        visible:false,
      }
    ]
  },
  {
    name: 'trasmissione-reportnet',
    label: 'Trasmissione Reportnet3',
    icon: 'report',
    subMenu: [
/*       {
        name: 'trasmissione_reportnet_invio_dati',
        label: 'Trasmissione dati Reportnet3',
        icon: 'cloud_upload',
        link: '/trasmissione-reportnet/invio-dati'
      }, */
      {
        name: 'trasmissione_reportnet3_lista_page',
        label: 'Lista Reportnet3',
        icon: 'list',
        link: '/trasmissione-reportnet/lista-page'
      },
      {
        name: 'trasmissione_reportnet_invio_file',
        label: 'Trasmissione file Reportnet3',
        icon: 'upload_file',
        link: '/trasmissione-reportnet/invio-file'
      },
    ]
  },
  {
    name: 'parametri',
    label: 'Parametri',
    icon: 'science',
    link: '/parametri/lista',
  },
  {
    name: 'acquedotti',
    label: 'Acquedotti',
    icon: 'valve',
    link: '/acquedotti/lista',
    // subMenu: [
    //   {
    //     name: 'acquedotti-lista',
    //     label: 'Visualizza dati',
    //     icon: 'list',
    //     link: '/acquedotti/lista',
    //     // separator: true
    //   },
    // ]
  },
  {
    name: 'water-supply-zone',
    label: 'Water Supply Zone',
    icon: 'water',
    link: '/water-supply-zone/lista',
    // subMenu: [
    //   {
    //     name: 'water-supply-zone-lista',
    //     label: 'Visualizza dati',
    //     icon: 'list',
    //     link: '/water-supply-zone/lista',
    //     // separator: true
    //   },
    // ]
  },
  {
    name: 'arera',
    label: 'Tabelle Arera',
    icon: 'stars',
    subMenu: [
      {
        name: 'arera-ato',
        label: 'ATO',
        icon: 'stars',
        link: '/arera-ato/lista'
      },
      {
        name: 'arera-gestore',
        label: 'Gestore',
        icon: 'stars',
        link: '/arera-gestore/lista'
      },
    ]
  },
  {
    name: 'istat',
    label: 'Tabelle ISTAT',
    icon: 'monitoring',
    subMenu: [
      {
        name: 'istat-regioni',
        label: 'Regioni',
        icon: 'south_america',
        iconPage: 'south_america',
        link: '/istat-regioni/lista'
      },
      {
        name: 'istat-comuni',
        label: 'Comuni',
        icon: 'location_city',
        iconPage: 'location_city',
        link: '/istat-comuni/lista'
      },
    ]
  },
  {
    name: 'elaborazioni',
    label: 'Elaborazioni',
    icon: 'manufacturing',
    subMenu: [
      {
        name: 'elaborazioni-lista-page',
        label: 'Lista elaborazioni',
        icon: 'list',
        link: '/elaborazioni/lista'
      }
    ]
  },
  {
    name: 'credenziali-api',
    label: 'API KEY',
    icon: 'key',
    link: '/credenziali-api'
  },
  {
    name: 'admin',
    label: 'Pannello di Amministrazione',
    icon: 'admin_panel_settings',
    subMenu: [
      {
        name: 'amministrazione_users',
        label: 'Utenti',
        icon: 'group',
        link: '/admin/users'
      },
      {
        name: 'amministrazione_enti',
        label: 'Enti',
        icon: 'hub',
        link: '/admin/enti'
      },
/*       {
        name: 'roles',
        label: 'Ruoli',
        icon: 'rule',
        link: '/roles'
      },
      {
        name: 'teams',
        label: 'Teams',
        icon: 'hub',
        link: '/teams'
      },
      {
        name: 'tenant',
        label: 'Entità',
        icon: 'folder_managed',
        link: '/tenant'
      } */
    ]
  },
]

